export {default as authRoutes} from './auth';

const routes = {
    root: '/',
    logout: '/logout',
    notFound: '/error'
};

export default routes;
